var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseGridLayout',{attrs:{"id":_vm.anchorName,"size":"small"}},[_c('div',{staticClass:"col-span-full"},[_c('LeadGeneration',{attrs:{"headline":_vm.headline,"contact-data":_vm.contactData,"form-data":_vm.formData,"location-data":_vm.locationData,"positions":_vm.positions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }